// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { AirTrafficControlIcon } from '@moia-dev/pace-icons'
import { RemoteAssistanceOperatorAreaRoutes } from './RemoteAssistanceOperatorAreaRoutes'

export const RemoteAssistanceOperatorAreaNavigationIcon = AirTrafficControlIcon

export const RemoteAssistanceOperatorAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={RemoteAssistanceOperatorAreaRoutes.route}
      Icon={AirTrafficControlIcon}
    />
  )
}
